import { createSlice } from '@reduxjs/toolkit';

export const initialQuestionState = {
    searchId: '',
    title: '',
    content_Id: '',
    customDescription: '',
    addInstruction: '',
    attempt: true,
};

export const REMEDIAL_KEY ={
    REMEDIAL:'remedial',
    PAGE:'page'
}

export const DEFAULT_PAGE_STATE = {
    [`${REMEDIAL_KEY.PAGE}1`]: {
        question: { ...initialQuestionState },
    }
}

export const generateInitialState = (noOfRemidialPage: number) => {
    const initialRemedialQuestionState: any = {};
    for (let i = 1; i <= noOfRemidialPage; i++) {
        initialRemedialQuestionState[`${REMEDIAL_KEY.REMEDIAL}${i}`] = {
            pageState: {
                [`${REMEDIAL_KEY.PAGE}1`]: {
                    question: { ...initialQuestionState },
                }
            }
        };
    }
    return initialRemedialQuestionState;
};

export const generateIsRemedialSliceUpdatedMap = (noOfRemedialPage: number) => {
    const isRemedialSliceUpdatedMap: any = {};
    for (let i = 1; i <= noOfRemedialPage; i++) {
        isRemedialSliceUpdatedMap[`${REMEDIAL_KEY.REMEDIAL}${i}`] = true;
    }
    return isRemedialSliceUpdatedMap;
};

export const initialRemedialQuestionState = {
    noOfRemedialPage: 1,
    remedialState: generateInitialState(1),
    isRemedialSliceUpdatedMap: generateIsRemedialSliceUpdatedMap(1),
}


const remedialQuestionSlice = createSlice({
    name: 'RemedialQuestionData',
    initialState: {
        ...initialRemedialQuestionState
    },
    reducers: {
        setInitialState: (state, action) => {
            const noOfRemedialPage = action.payload;
            const newState = generateInitialState(noOfRemedialPage);
            const newUpdatedRemedialMap = generateIsRemedialSliceUpdatedMap(noOfRemedialPage);
            return { ...state, remedialState: newState, noOfRemedialPage: noOfRemedialPage, isRemedialSliceUpdatedMap: newUpdatedRemedialMap };
        },
        addRemedialQuestion: (state, actionType) => {
            state.remedialState = actionType.payload;
        },
        setRemedialSliceUpdated: (state, action) => {
            const { key, value } = action.payload;
            state.isRemedialSliceUpdatedMap[key] = value;
        },
    }
});

const { actions, reducer } = remedialQuestionSlice;
export default reducer;
export const remedialQuestionActions = actions;